import type { Channels } from 'v2/types/api/conversations'

export enum MIMETYPE {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  APPLICATION = 'application',
  TEXT = 'text',
}

export interface MediaFile {
  file_url: string
  file_name: string
  file_type: string
  file_size: number
}

export interface MediaProps {
  file: {
    file_url: string
    file_name: string
    file_type: string
    file_size: number
    file_id?: string
  }
  message?: string
  onPreview: (file: MediaProps['file']) => void
  multipleMedia?: boolean
  isOutbound?: boolean
  senderId?: string
  contactUuid?: string
  channel?: Channels
  hideMessage?: boolean
}

export interface AudioPlayerHandle {
  play: () => void
  pause: () => void
  isPlaying: () => boolean
}

export interface AudioPlayerProps {
  url: string
  fileName: string
  className?: string
  loading?: boolean
  audioPlayerRef?: React.RefObject<AudioPlayerHandle>
}
